/**
 * Schlankes Toast-System ohne Provider/Context: ein modulweiter Store, den
 * ToastHost abonniert. toast(...) kann von überall aufgerufen werden, ohne
 * dass die aufrufende Komponente etwas rendern oder importieren muss außer
 * dieser einen Funktion.
 */
export type ToastKind = "success" | "error" | "info";
export interface ToastMsg { id: number; kind: ToastKind; text: string }

let toasts: ToastMsg[] = [];
let listeners: ((t: ToastMsg[]) => void)[] = [];
let counter = 0;

function emit() {
  for (const l of listeners) l(toasts);
}

export function subscribeToasts(listener: (t: ToastMsg[]) => void): () => void {
  listeners.push(listener);
  return () => { listeners = listeners.filter((l) => l !== listener); };
}

export function toast(text: string, kind: ToastKind = "info") {
  const id = ++counter;
  toasts = [...toasts, { id, kind, text }];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id);
    emit();
  }, 4200);
}

export function dismissToast(id: number) {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}
